<template>
  <div style="font-size: 16rem;">
    <div v-if="page_mode==0">
      <div style="width:1920rem;background: #f4f4f4;position: relative;">
        <img style="display:block;width:1300rem;padding-left: 310rem;" src="../assets/zsp/head_banner.png">
        <div style="position: absolute;left:550rem;top:320rem;background: #3a7fb6;border-radius: 25rem;width:150rem;height:50rem;" @click="page_mode=1">
          <div style="color:white;font-size: 22rem;text-align: center;padding-top:12rem;">开始制作</div>
        </div>
        <div style="position: absolute;left:985rem;top:320rem;background: #3a7fb6;border-radius: 25rem;width:150rem;height:50rem;" @click="page_mode=2">
          <div style="color:white;font-size: 22rem;text-align: center;padding-top:12rem;">开始制作</div>
        </div>
        <div style="position: absolute;left:1420rem;top:320rem;background: #3a7fb6;border-radius: 25rem;width:150rem;height:50rem;" @click="show_kefu_panel=true">
          <div style="color:white;font-size: 22rem;text-align: center;padding-top:12rem;">立即咨询</div>
        </div>
      </div>
      <div style="padding-left:400rem;">
        <div style="font-size:24rem;color:#666666;padding-top:100rem;">您可以用数字人制作:</div>
        <div class="horizontal" style="padding-top:15rem;">
          <div v-for="(item, index) in sceneExamples" :key="index" style="margin-right: 30rem;">
            <img style="display:block;width:270rem;" v-bind:src="item.image">
            <div style="padding-top:5rem;text-align: center;">{{ item.text }}</div>
          </div>
          <!--
          <div>
            <div style="background: #b37728;border-radius: 24rem;width:220rem;height:48rem;margin-top:10rem;">
              <div style="color:white;text-align: center;padding-top:12rem;">全域操盘陪跑服务</div>
            </div>
            <div style="background: #3a80b6;border-radius: 24rem;width:220rem;height:48rem;margin-top:10rem;">
              <div style="color:white;text-align: center;padding-top:12rem;">虚拟IP形象有奖征集</div>
            </div>
          </div>
          -->
        </div>
      </div>
    </div>
    <div v-if="page_mode==1" style="margin:20rem 375rem;">
      <div class="horizontal" style="color:white;text-align: center;">
        <div style="margin-right:327rem;">
          <span style="color:#92bedb;text-decoration:underline;" @click="page_mode=0">返回/</span>
          <span style="color:#666666;"> 我的分身</span>
        </div>
        <div style="width:80rem;background: #3a7fb6; padding:10rem;margin-right: 16rem;">我的分身</div>
        <div style="width:80rem;background: #92bedb; padding:10rem;" @click="page_mode=2">模特</div>
      </div>
      <div class="horizontal" style="overflow: auto;">
        <div v-for="index in [0,1,2,3,4,5,6,7]" :key="index" style="margin:15rem;">
          <div v-if="index<user_mote_list.length">
            <div :class="{ 'selected':mote_pos==index}" style="width:240rem;height:135rem;border-radius: 15rem;background: #999999;position: relative;" @click="playVideo(0,index)">
              <img style="display:block; height: 100%;margin:auto;" v-bind:src="user_mote_list[index].image_cover_url">
              <div v-if="user_mote_list[index].status!=1" style="position: absolute;left:0;top:0;right:0;bottom: 0; background: rgba(100,100,100,0.2);border-radius: 15rem;">
                <img class="waitingImg" src="../assets/zsp/ic_loading.png">
              </div>
            </div>
            <div v-if="mote_pos==index" class="mkbutton">
              <span v-if="user_mote_list[index].status==1" @click="generate_panel=true">使用视频制作</span>
              <span v-else @click="loadMoteList">刷新</span>
            </div>
          </div>
          <img v-else-if="index<max_user_mote_num" style="display:block; width: 240rem;" src="../assets/zsp/user_bg1.png" @click="upload_mote_step=0">
          <img v-else style="display:block; width: 240rem;" src="../assets/zsp/user_bg2.png" @click="show_kefu_panel=true">
        </div>
      </div>
      <div style="margin-left:15rem; margin-right:105rem;height:1rem;background: #e5e5e5;"></div>
    </div>
    <div v-if="page_mode==2" style="margin:20rem 375rem;">
      <div class="horizontal" style="color:white;text-align: center;">
        <div style="margin-right:358rem;">
          <span style="color:#92bedb;text-decoration:underline;" @click="page_mode=0">返回/</span>
          <span style="color:#666666;"> 模特</span>
        </div>
        <div style="width:80rem;background:#92bedb; padding:10rem;margin-right: 16rem;" @click="page_mode=1">我的分身</div>
        <div style="width:80rem;background:#3a7fb6; padding:10rem;">模特</div>
      </div>
      <div class="horizontal" style="overflow: auto;flex-wrap: nowrap;">
        <div v-for="(item, index) in mote_list" :key="index" style="margin:15rem;">
          <div :class="{ 'selected':mote_pos==index}" style="width:240rem;height:135rem;border-radius: 15rem;background: #999999;" @click="playVideo(1,index)">
            <img style="display:block; height:100%;margin:auto;" v-bind:src="item.image_cover_url">
          </div>
          <div v-if="mote_pos==index" class="mkbutton" @click="generate_panel=true">使用视频制作</div>
        </div>
      </div>
      <div style="margin:0 15rem;height:1rem;background: #e5e5e5;"></div>
      <div style="text-align: center;margin-top:15rem;">选择背景</div>
      <div class="horizontal" style="overflow: auto;flex-wrap: nowrap;">
        <div v-for="(item, index) in bgv_list" :key="index" style="margin:15rem;" @mouseenter="mouse_idx1=index" @mouseleave="mouse_idx1=-1" @click="selectBgv(index)">
          <div :class="{ 'selected':bgv_pos==index}" style="width:240rem;height:135rem;border-radius: 15rem;background: #f6f6f6;">
            <video v-if="mouse_idx1==index && item.video_example" ref="bgVideoRef" style="width:100%;height:100%;" muted autoplay>
              <source :src="item.video_example" type="video/mp4">
            </video>
            <img v-else style="display:block; height:100%;margin:auto;" v-bind:src="item.image_cover_url">
          </div>
          <div style="text-align: center;padding-top: 5rem;">{{ item.title }}</div>
        </div>
      </div>
      <div style="margin:0 15rem;height:1rem;background: #e5e5e5;"></div>
      <div style="text-align: center;margin-top: 15rem;">选择背景音乐</div>
      <div class="horizontal" style="overflow: auto;flex-wrap: nowrap;">
        <div v-for="(item, index) in bgm_list" :key="index" style="margin:15rem;" @mouseenter="playBgAudio(index)" @mouseleave="playBgAudio(-1)" @click="selectBgm(index)">
          <div :class="{ 'selected':bgm_pos==index}" style="width:240rem;height:135rem;border-radius: 15rem;background: #f6f6f6;position: relative;">
            <img style="display:block; height:100%;margin:auto;" v-bind:src="item.image_cover_url">
            <div v-if="mouse_idx2==index" style="position: absolute;left:0;top:0;right:0;bottom: 0;">
              <AudioPlayingStyle/>
            </div>
          </div>
          <div style="text-align: center;padding-top: 5rem;">{{ item.title }}</div>
        </div>
      </div>
      <div style="margin:0 15rem;height:1rem;background: #e5e5e5;"></div>
    </div>
    <div v-if="show_kefu_panel" class="mask">
      <div style="background:white;border-radius: 15rem;">
        <img style="float:right;display:block;width:20rem;height:20rem;margin:10rem;" src="../assets/zsp/close_x.png" @click='show_kefu_panel=false'/>
        <div style="width: 400rem;height: auto;margin:35rem 50rem;color:#444444;font-size:18rem;text-align: center;">
          <div>联系我们定制专属虚拟数字人</div>
          <img style="display: block;width:200rem;margin: 20rem auto;" src="../assets/tongtu/kefuerweima.png">
          <div>联系电话:18501641153</div>
        </div>
      </div>
    </div>
    <div v-if="upload_mote_step>=0" class="mask">
      <div style="background:white;border-radius: 15rem;">
        <img style="float:right;display:block;width:20rem;height:20rem;margin:10rem;" src="../assets/zsp/close_x.png" @click='upload_mote_step=-1'/>
        <div style="width: 600rem;height: auto;margin:35rem 50rem;color:white;">
          <div v-if="upload_mote_step==0" style="position: relative;">
            <img style="display: block;width: 600rem;" src="../assets/zsp/upload/1.png">
            <div class="uploadbutton" @click="upload_mote_step=1">制作分身</div>
            <video style="position:absolute;left:210rem;top:60rem;height:330rem;" muted autoplay>
              <source :src="mote_list[0].video_example" type="video/mp4">
            </video>
          </div>
          <div v-if="upload_mote_step==1" style="position: relative;">
            <img style="display: block;width: 600rem;" src="../assets/zsp/upload/2.png">
            <div class="uploadbutton" @click="upload_mote_step=2">下一步</div>
          </div>
          <div v-if="upload_mote_step==2" style="position: relative;">
            <img style="display: block;width: 600rem;" src="../assets/zsp/upload/3.png">
            <input type="file" ref="videoInputRef" style="display: none" accept="video/*" @change="handleVideoFileChange" />
            <div class="uploadbutton" style="top:200rem;" @click="$refs.videoInputRef.click();">上传视频</div>
            <img style="position:absolute;left:120rem;top:400rem;width:160rem;" v-bind:src="sceneExamples[0].image">
            <img style="position:absolute;left:300rem;top:400rem;width:160rem;" v-bind:src="sceneExamples[1].image">
          </div>
          <div v-if="upload_mote_step==3" style="position: relative;">
            <img style="display: block;width: 600rem;" src="../assets/zsp/upload/4.png">
            <div class="uploadbutton" @click="addUserMote">生成数字人</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="page_mode!=0 && generate_panel">
      <div class="horizontal" style="margin:10rem 0 10rem 390rem;color:white;text-align: center;">
        <div class="horizontal">
          <div v-if="mote_size==0" style="width:50rem;background:#3a7fb6; padding:10rem;margin-right: 16rem;">手机</div>
          <div v-else style="width:50rem;background:#92bedb; padding:10rem;margin-right: 16rem;" @click="mote_size=0">手机</div>
          <div v-if="mote_size==1" style="width:50rem;background:#3a7fb6; padding:10rem;">电脑</div>
          <div v-else style="width:50rem;background:#92bedb; padding:10rem;" @click="mote_size=1">电脑</div>
        </div>
        <div>
          <img v-if="mote_size==1" style="display: block;width:400rem;height:300rem;margin-left:170rem;" src="../assets/zsp/43bg.png">
          <img v-else style="display: block;width:216rem;height:384rem;margin-left:260rem;" src="../assets/zsp/169bg.png">
        </div>
      </div>
      <input type="file" ref="audioInputRef" style="display: none" accept="audio/*" @change="handleAudioFileChange"/>
      <div style="margin:5rem 1340rem;position: relative;">
        <div v-if="select_audio_file==null" style="width:65rem;background:#3a7fb6; padding:8rem 16rem;border-radius: 20rem; color:white;" @click="$refs.audioInputRef.click()">上传语音</div>
        <div v-else>
          <div style="width:65rem;background:red; padding:8rem 16rem;border-radius: 20rem; color:white;" @click="delAudioFile">删除语音</div>
          <div style="position: absolute;top:5rem;right:0rem;min-width: 180rem;" v-if="select_audio_file">{{ select_audio_file.name }}</div>
        </div>
      </div>
      <textarea v-model="tts_text" style="margin-left:390rem;width: 1040rem;height:160rem;background: white;" :readonly="select_audio_file"></textarea>

      <div class="horizontal" style="margin:10rem 0 10rem 840rem;">
        <div style="width:120rem;text-align: center; background: #715af6;padding: 10rem;border-radius: 10rem;color:white;font-size: 20rem;" @click="generate">
          <span v-if="generate_status==0">确认</span>
          <span v-if="generate_status==1">开始生成</span>
        </div>
        <div v-if="generate_money>0" style="font-size: 18rem;padding-left: 10rem;">
          <span>预估生成此视频需要消耗 </span>
          <span style="color: red;"> {{ generate_money }}</span>
          <span> AI币</span>
        </div>
      </div>
    </div>
    <div v-if="show_player_panel" class="mask">
      <div style="background:white;border-radius: 15rem;">
        <img style="float:right;display:block;width:20rem;height:20rem;margin:10rem;" src="../assets/zsp/close_x.png" @click='show_player_panel=false'/>
        <div style="width: 400rem;height: auto;margin:35rem 10rem;">
          <video-player class="video-player vjs-custom-skin"
            :playsinline="true" 
            :options="playerOptions">
          </video-player>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import {Howl} from 'howler'
import { PLAY_OPTION,generateRandomString } from './util'
import AudioPlayingStyle from './AudioPlayingStyle.vue'

export default {
  components: { AudioPlayingStyle },
  props: {
    userID: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      mote_list:[],
      bgv_list:[],
      bgm_list:[],

      aiMoney:0,

      user_mote_list:[],
      max_user_mote_num:2,
      mote_size:0,

      page_mode:0,
      mote_pos:0,
      bgv_pos:-1,
      bgm_pos:-1,

      select_video_file:null,
      select_video_url:"",
      select_video_server:"",

      select_audio_file:null,
      select_audio_url:"",
      select_audio_server:"",

      mouse_idx1:-1,
      mouse_idx2:-1,
      playerOptions:PLAY_OPTION,

      upload_mote_step:-1,
      show_kefu_panel:false,
      show_player_panel:false,
      generate_panel:false,

      generate_money:0,
      generate_status: 0,
      tts_text:"",
      sound:null,

      sceneExamples:[{
        image:require("../assets/zsp/tema1.png"),
        text:"口播视频"
      },{
        image:require("../assets/zsp/tema2.png"),
        text:"教学视频"
      },{
        image:require("../assets/zsp/tema3.png"),
        text:"产品视频"
      }],
      loading:false
    }
  },
  
  created() {
    document.title = ''
    this.getRouterData()
  },
  destroyed() {
    //
  },
  methods: {
    getRouterData() {
      this.loadMoteList()
      this.orderInfo()
    },
    async loadMoteList() {
      if (this.loading) return
      this.loading = true

      let request_data = {
        'type': 'talkingface_mote_list',
        'data': {
          'user_id': this.userID
        }
      }
      await axios.post('https://caixiaowen.com/zsp', JSON.stringify(request_data))
        .then((result) => {
          console.log(result.data)
          this.mote_list = result.data.mote_list
          this.user_mote_list = result.data.user_mote_list
          this.bgv_list = result.data.bgv_list
          this.bgm_list = result.data.bgm_list
          this.loading = false
        }).catch((error) => {
          console.log(error)
          this.loading = false
        })
    },
    async addUserMote(){
      let request_data = {
        'type': 'talkingface_add_user_mote',
        'data': {
          'user_id': this.userID,
          "video_url":this.select_video_url,
          "video_server":this.select_video_server
        }
      }
      await axios.post('https://caixiaowen.com/zsp', JSON.stringify(request_data))
        .then((result) => {
          console.log(result.data)
          this.upload_mote_step=-1
          if(result.data.err_no==0){
            this.user_mote_list.push(result.data)
          } else {
            alert("分身制作失败，请检查视频，或联系客服处理！")
          }
        }).catch((error) => {
          console.log(error)
        })
    },
    orderInfo(){
      let request_data = {
        'type': 'order_info',
        'data': {
          'user_id': this.userID,
          'album_id': 'AI00'
        }
      }
      axios.post('https://caixiaowen.com/tongtu', JSON.stringify(request_data))
        .then((result) => {
          console.log(result.data)
          if(result.data.order_list.length>0){
            let t = JSON.parse(result.data.order_list[0])
            this.aiMoney = "" + parseFloat(t.ai_money).toFixed(2)
            this.$emit('updateMoney', this.aiMoney)
          }
        }).catch((error) => {
          console.log(error)
        })
    },
    delAudioFile(){
      this.$refs.audioInputRef.value = null
      this.tts_text="请输入文字..."
      this.select_audio_file = null
    },
    handleAudioFileChange(event){
      if(event.target.files.length>0){
        this.select_audio_file = event.target.files[0]
        console.log(this.select_audio_file.name)
        this.tts_text="请先删除语音文件，再使用声音合成功能"
      }
    },
    async handleVideoFileChange(event){
      if(event.target.files.length>0){
        this.select_video_file = event.target.files[0]
        console.log(this.select_video_file.name)
      } else {
        return
      }
      if(this.select_video_file.size > 100 * 1024 * 1024) {
        alert("视频文件限制，超过了100M")
        return
      }
      alert("正在上传，请不要关闭，否则将失败!")

      const formData2 = new FormData();
      formData2.append("file", this.select_video_file)
      await axios
        .post("https://caixiaowen.com/zsp", formData2, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          console.log(response.data)
          if(response.data.err_no==0){
            this.select_video_url = response.data.file_url
            this.select_video_server = response.data.file_local
            this.upload_mote_step=3
            console.log(this.select_video_url)
          }
        })
        .catch((error) => {
          console.error(error)   
        })
    },
    selectBgv(index){
      if(this.bgv_pos == index){
        this.bgv_pos = -1
      } else {
        this.bgv_pos = index
      }
    },
    selectBgm(index){
      if(this.bgm_pos == index){
        this.bgm_pos = -1
      } else {
        this.bgm_pos = index
      }
    },
    playVideo(type,index){
      var video_url=""
      if(type==1) video_url = this.mote_list[index].video_example
      if(type==0) video_url = this.user_mote_list[index].video_url
      this.mote_pos=index
      this.show_player_panel=true

      this.playerOptions.controls = false
      this.playerOptions.sources=[{
        type: "video/mp4",
        src: video_url
      }]
    },
    playBgAudio(index){
      this.sound && this.sound.stop()
      this.mouse_idx2=index
      if(index>=0){
        console.log(this.bgm_list[index].audio_url)
        this.sound = new Howl({
          src: [this.bgm_list[index].audio_url]
        })   
        this.sound.play()
      }
    },
    async generate(){
      if(this.generate_status==0){
        if(this.select_audio_file != null){
          if(this.select_audio_file.size > 10 * 1024 * 1024) {
            alert("音频文件限制，超过了10M")
            return
          }
          const formData2 = new FormData();
          formData2.append("file", this.select_audio_file)
          await axios
            .post("https://caixiaowen.com/zsp", formData2, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              console.log(response.data)
              if(response.data.err_no==0){
                this.select_audio_url = response.data.file_url
                this.select_audio_server = response.data.file_local
              }
            })
            .catch((error) => {
              console.error(error)   
            })
          if(this.select_audio_url==""){
            alert("音频上传失败")
            return
          }
          //
          const audio = new Audio();
          audio.src = URL.createObjectURL(this.select_audio_file)
          audio.onloadedmetadata = () => {
            console.log(audio.duration)
            if(audio.duration>120){
              alert("文件限制，超过了2分钟，请联系客服定制")
            } else {
              this.generate_money = ((audio.duration/30)*0.5).toFixed(1)
              if(this.generate_money<0.5) this.generate_money = 0.5
              if(this.generate_money>parseFloat(this.aiMoney)){
                this.generate_money = 0
                alert("余额不足,请先充值")
              } else{
                this.generate_status = 1
              }
            }
          };
        } else {
          if(this.tts_text.length>300){
            alert("字数限制，超过了300字，请联系客服定制")
          } else {
            this.generate_money = ((this.tts_text.length/90)*0.5).toFixed(1)
            if(this.generate_money<0.5) this.generate_money = 0.5
            if(this.generate_money>parseFloat(this.aiMoney)){
              this.generate_money = 0
              alert("余额不足,请先充值")
            } else{
              this.generate_status = 1
            }
          }
        }
        return
      }
      this.generate_money = 0
      
      //
      const now = new Date()
      let title = now.toLocaleString()
      console.log("title",title)

      let sid = generateRandomString(10)
      var request_data = {}
      if(this.page_mode==1){
        request_data = {
          'type': 'talkingface_video_generate',
          'data': {
            'user_id': this.userID,
            'title':title,
            'sid': sid,
            'user_mote_pos':this.mote_pos,
            'image_url': this.user_mote_list[this.mote_pos].image_cover_url
          }
        }
      } else {
        request_data = {
          'type': 'talkingface_video_generate',
          'data': {
            'user_id': this.userID,
            'title':title,
            'sid': sid,
            'mote_pos':this.mote_pos,
            'image_url': this.mote_list[this.mote_pos].image_cover_url
          }
        }
        if(this.bgv_pos>=0)request_data['data']['bgv_pos'] = this.bgv_pos
        if(this.bgm_pos>=0)request_data['data']['bgm_pos'] = this.bgm_pos
      }
      if(this.select_audio_file != null){
        request_data['data']['audio_server'] = this.select_audio_server
        request_data['data']['audio_url'] = this.select_audio_url
      } else {
        request_data['data']['tts_text'] = this.tts_text
      }

      axios.post('https://caixiaowen.com/zsp', JSON.stringify(request_data))
        .then((result) => {
          console.log(result.data)
          if(result.data.err_no==0){
            this.generate_panel = false
            this.generate_status = 0
            this.mote_pos = -1
            this.bgv_pos = -1
            this.bgm_pos = -1
            this.orderInfo()
            alert("正在生成中，需要一些时间，请在我的视频查看结果")
          }
        }).catch((error) => {
          console.log(error)
        })
    }
  }
}

</script>

<style>
.horizontal {
  flex-direction: row;
  display: flex;
  position: relative;
}
.mkbutton {
  width:100rem;
  background: #3a7fb6;
  border-radius: 15rem;
  padding:8rem;
  color:white;
  font-size:16rem;
  text-align:center;
  margin:5rem auto 0 auto;
}
.uploadbutton {
  position: absolute;
  left:250rem;
  top:430rem;
  background: #3a7fb6;
  border-radius: 10rem;
  padding: 10rem;
}
.selected {
  border: 1rem solid #3a7fb6;
}

.waitingImg {
  display: block;
  width: 40rem;
  height: 40rem;
  margin:60rem auto;
  animation: rotateImg 8s linear infinite;
}
@keyframes rotateImg {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, .3);
  z-index: 9999;

  width: 100%;
  height: 100vh;

  display: flex;
  align-items: center;
  justify-content: center;
}
</style>